import React from "react";
import styled from "@emotion/styled";
import { TitleThickThin } from "@components/titles";
import { useTranslations } from "next-intl";
import WsSectionTitleWithThinTitle from "@components/a1-refactor/typography/WsSectionTitleWithThinTitle copy";
import { Box } from "@mui/material";

const BankLogos = [
  { src: "/icons/banco_popular_logo.svg", alt: "Logo Banco Popular" },
  { src: "/icons/banco_reservas_logo.svg", alt: "Logo Banco Reservas" },
  { src: "/icons/banco_bhd_logo.svg", alt: "Logo Banco BHD" },
  { src: "/icons/scotiabank_logo.svg", alt: "Logo ScotiaBank" },
];
function CoverSection() {
  const translation = useTranslations("mortgageForm");
  const translationLoan = useTranslations("mortgageForm.loan");

  const title = translation("title") || "";

  const [titleOne, titleTwo, ...rest] = title.split(" ");

  return (
    <CoverBackground>
      <InformationContainer>
        <BoxTitle>
          <WsSectionTitleWithThinTitle
            title={`${titleOne} ${titleTwo}`}
            subtitle={rest.join(" ")}
            color="white"
          />
        </BoxTitle>

        <BoxText className="cover__text">{translationLoan("apply")}</BoxText>
        <BoxText className="cover__text">{translationLoan("process")}</BoxText>
        <BoxText className="cover__text">{translationLoan("help")}</BoxText>
      </InformationContainer>
      <BorderContainer />
    </CoverBackground>
  );
}``

export default CoverSection;

const BorderContainer = styled.div`
  position: absolute;
  bottom: 0;
  border-radius: 100px 0 0 0;
  padding: 2.5rem;
  width: 100%;
  background: var(--color-brand-cream-primary);
  z-index: 100;
  display: block;
  @media screen and (max-width: 1100px) {
    display: none;
  }
`;

const CoverBackground = styled.div`
  position: relative;
  background-position: right 15% bottom -10%;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 85vh;
  background-image: url("/images/v2/pic/image-05.webp");
  @media screen and (max-width:1100px) {
    background-position: right 15% bottom 35dvh;
  }
`;

const InformationContainer = styled.div`
  z-index: 2;
  padding: 20px;
  background: var(--color-brand-blue-main);
  border-radius: 8px;

  @media screen and (max-width: 1100px) {
    left: 25%;
  }
  @media screen and (min-width: 1100px) {
    position: absolute;
    top: 60%;
    left: 20%;
    transform: translate(-50%, -50%);
    min-height: 350px;
    max-width: 450px;
    height: 400px;
  }
  @media screen and (max-width: 1100px) {
    max-width: 100%;
    width: 100%;
    transform: none;
    position: absolute;
    bottom: 0px;
    left: 0%;
    border-radius: 0px;
  }
`;

const BoxTitle = styled.div`
  color: #fff;
  font-weight: 700;
  margin-bottom: 10px;
  * {
    font-size: 1.5rem;
  }
`;

const BoxText = styled.div`
  color: #fff;
  font-size: 0.838rem;
  font-weight: 400;
  margin-bottom: 20px;
  line-height: 20px;
  @media screen and (max-width: 1200px) {
    text-align: center;
  }
`;
